/* eslint-disable no-param-reassign */
// NOTE: This file is included in nav.js, making it included on every page.

// There is no need to manually add this to individual pages.
(function onPageLoad() {
  // Accordion hover style should only apply to the unchecked elements - provide
  // a CSS class to make that possible:

  const accordionSelectableSections = Array.from(
    document.querySelectorAll('.accordion-js button:not([name^=compare-table-])')
  );

  let buttonTabbed = false;
  const handleDirectionalKeys = (
    handleTurnPosition,
    indexOfTurnPosition,
    commonDisplacement,
    activeElement,
    indexOfActiveElement
  ) => {
    if (accordionSelectableSections.includes(activeElement)) {
      if (indexOfActiveElement === handleTurnPosition) {
        accordionSelectableSections[indexOfTurnPosition].focus();
      } else {
        accordionSelectableSections[commonDisplacement].focus();
        if (commonDisplacement === indexOfActiveElement - 1) {
          window.scrollBy(0, -50);
        } else {
          window.scrollBy(0, 50);
        }
      }
    }
  };
  window.addEventListener('keydown', e => {
    const { activeElement } = document;
    const indexOfActiveElement = accordionSelectableSections.indexOf(activeElement);
    if (accordionSelectableSections.includes(activeElement)) {
      switch (e.key) {
        case 'Enter': {
          e.preventDefault();
          activeElement.classList.toggle('checked');
          break;
        }
        case ' ': {
          e.preventDefault();
          activeElement.classList.toggle('checked');
          break;
        }
        case 'ArrowUp': {
          e.preventDefault();
          handleDirectionalKeys(
            0,
            accordionSelectableSections.length - 1,
            indexOfActiveElement - 1,
            activeElement,
            indexOfActiveElement
          );
          break;
        }
        case 'ArrowDown': {
          e.preventDefault();
          handleDirectionalKeys(
            accordionSelectableSections.length - 1,
            0,
            indexOfActiveElement + 1,
            activeElement,
            indexOfActiveElement
          );
          break;
        }
        default:
          break;
      }
    }
  });

  Array.from(document.querySelectorAll('.accordion-js button:not([name^=compare-table-])')).forEach(
    input => {
      buttonTabbed = false;
      Array.from(input.closest('.accordion-js').querySelectorAll('button')).forEach(button => {
        button.setAttribute('tabindex', '0');
        button.setAttribute('aria-expanded', 'false');

        input.addEventListener('click', () => {
          input.closest('button').classList.toggle('checked');
        });

        button.addEventListener('focus', () => {
          if (buttonTabbed) {
            button.classList.add('checked');
          }
          buttonTabbed = false;
        });

        button.addEventListener('focusout', () => {
          button.classList.remove('checked');
          button.setAttribute('aria-expanded', 'false');
        });
      });
    }
  );
  Array.from(document.querySelectorAll('.accordion-js input:not([name^=compare-table-])')).forEach(
    input => {
      input.addEventListener('click', () => {
        Array.from(input.closest('.accordion-js').querySelectorAll('label'))
          .filter(label => label !== input.closest('label'))
          .forEach(label => label.classList.remove('checked'));
        input.closest('label').classList.toggle('checked');
      });
    }
  );
})();
